import remarkGfm from "remark-gfm";
import type { PluggableList } from "unified";

// 回答では「3~5%」のような範囲表記で単一チルダが頻出するため、取り消し線は二重チルダのみに限定する
export const remarkPlugins: PluggableList = [
  [remarkGfm, { singleTilde: false }],
];
